import { render, staticRenderFns } from "./SalaryReceiptDetail.vue?vue&type=template&id=6cbaadd0&scoped=true&"
import script from "./SalaryReceiptDetail.vue?vue&type=script&lang=js&"
export * from "./SalaryReceiptDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalaryReceiptDetail.vue?vue&type=style&index=0&id=6cbaadd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbaadd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cbaadd0')) {
      api.createRecord('6cbaadd0', component.options)
    } else {
      api.reload('6cbaadd0', component.options)
    }
    module.hot.accept("./SalaryReceiptDetail.vue?vue&type=template&id=6cbaadd0&scoped=true&", function () {
      api.rerender('6cbaadd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/SalaryReceiptDetail.vue"
export default component.exports